import ICategory from 'models/Category';

import { ReduxStore } from 'store/types';

function getAllList(state: ReduxStore): ICategory[] {
  return state.category.getAll.list;
}

export default getAllList;
